// extracted by mini-css-extract-plugin
export var createdDate = "_m9-1";
export var divider = "_m9-2";
export var headerDivider = "_m9-3";
export var messagesCard = "_m9-0";
export var messagesContainer = "_m9-6";
export var messagesContainerWrapper = "_m9-4";
export var showLeftPanelButton = "_m9-8";
export var topButtons = "_m9-7";
export var withPadding = "_m9-5";